module.exports = __webpack_public_path__ + "img/flag-american.2985389.svg";